import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import { Grid, SideSheet } from 'ui-toolkit';
import { Cover } from 'ui-toolkit';
import { ClientOrderContactForm } from './ClientOrderContactForm';
import { DeleteContactWarning } from '../subComponents/DeleteContactWarning';
import { clientOrderContactFormValidation } from '../../../../validation/order/ClientOrderContactFormValidation';
import { SideSheetEditContactFormFooter } from '../../../shared/SideSheetEditContactFormFooter';
import { IEditContactFormProps } from '../interfaces/IEditContactFormProps';
import { IClientContactData } from '../../../../types/contacts/IClientContact';
import { EditContactFormStatusWrapper } from '../subComponents/EditContactFormStatusWrapper';

interface IEditClientOrderContactFormProps extends IEditContactFormProps {
  initialData: IClientContactData;
}

export const EditClientOrderContactForm: React.FC<IEditClientOrderContactFormProps> = ({
  initialData,
  onSubmit,
  onCancel,
  onDelete,
  updateFetchError,
  updateFetchStatus,
  deleteFetchError,
  deleteFetchStatus,
  onResetDeleteContact,
}) => {
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);

  const showWarning = () => setShowDeleteWarning(true);
  const onResetThenCancel = () => {
    onResetDeleteContact();
    onCancel();
  };
  const onCancelDelete = () => {
    setShowDeleteWarning(false);
    onCancel();
  };
  return (
    <Formik
      initialValues={initialData}
      validateOnMount={true}
      validationSchema={clientOrderContactFormValidation}
      onSubmit={onSubmit}
      onReset={onCancel}
    >
      <Form>
        <SideSheet
          title={'Edit Contact'}
          onClose={onCancel}
          footer={
            <SideSheetEditContactFormFooter
              onCancel={onCancel}
              saveButtonText={'Save and Update'}
              showWarning={showWarning}
            />
          }
        >
          <Grid>
            <EditContactFormStatusWrapper
              fetching={updateFetchStatus.fetching || deleteFetchStatus.fetching}
              updateFetchedSuccess={updateFetchStatus.success}
              deleteFetchedSuccess={deleteFetchStatus.success}
              fetchError={updateFetchError || deleteFetchError}
              updateSuccessMessage={'Contact Updated!'}
              deleteSuccessMessage={'Contact Deleted!'}
              onResetDeleteAndCancel={onResetThenCancel}
            />
            <ClientOrderContactForm emailReadOnly={true} />
            {showDeleteWarning && (
              <Cover>
                <DeleteContactWarning
                  contactId={initialData.id}
                  onCancel={onCancelDelete}
                  onDelete={onDelete}
                  contactName={`${initialData.firstName} ${initialData.lastName}`}
                />
              </Cover>
            )}
          </Grid>
        </SideSheet>
      </Form>
    </Formik>
  );
};
